import React from 'react';
import { connect } from 'react-redux';
import Link from '../ZUILib/Link';
import breadcrumbconfig from './BreadcrumbConfig';
import commonUtil from '../../utils/commonUtil';
import serverClientUtil from '../../utils/serverClientUtil';

const applicationRoutes = commonUtil.getApplicationRoutes();
const { breadcrumbConfiguration } = require('../../utils/config/breadcrumbConfig');

@connect(store => ({
  eventDetails: store.eventDetail,
}),
)

export default class Breadcrumb extends React.Component {
  _getRoute = (route, oldtempBreadCrumb) => {
    let tempBreadCrumb = Object.assign([], oldtempBreadCrumb);
    if (route.parent && route.parent.route) {
      tempBreadCrumb = this._getRoute(route.parent);
      tempBreadCrumb.push(
        {
          route: route.route,
          displayName: route.displayName,
        },
      );
    } else {
      tempBreadCrumb.push(route);
    }
    return tempBreadCrumb;
  }
  _buildBreadcrumTrail = () => {
    const routeCount = this.props.Router.routes.length;
    let breadcrumbsForRoute = '';
    const currentRoute = this.props.Router.routes[routeCount - 1] && this.props.Router.routes[routeCount - 1].path ? this.props.Router.routes[routeCount - 1].path : this.props.Router.routes[routeCount - 2].path;
    if (this.props.params && this.props.params.pageName) {
      const index = currentRoute.indexOf('(');
      const path = currentRoute.substr(0, index);
      breadcrumbsForRoute = currentRoute && breadcrumbconfig[path] ? breadcrumbconfig[path] : null;
      const pageSpecificRoutes = breadcrumbsForRoute[breadcrumbsForRoute.length - 1];
      const pageRoute = pageSpecificRoutes[this.props.params.pageName];
      breadcrumbsForRoute.pop();
      breadcrumbsForRoute.push(pageRoute);
    } else if (this.props.params && this.props.params.eventID) {
      const index = currentRoute.indexOf('/');
      const path = currentRoute.substr(0, index);
      breadcrumbsForRoute = currentRoute && breadcrumbconfig[path] ? breadcrumbconfig[path] : null;
    } else {
      breadcrumbsForRoute = currentRoute && breadcrumbconfig[currentRoute] ? breadcrumbconfig[currentRoute] : null;
    }
    return breadcrumbsForRoute;
  }
  _createBreadCrumb = () => {
    let currentURL = '';
    let currentBreadCrumbConfiguration = [];
    // let isDynamicRoute = false;
    const currentPage = this.props.params.pageName;
    if (this.props.params && !commonUtil.isEmpty(this.props.params)) {
      // isDynamicRoute = true;
      const paramArray = Object.keys(this.props.params);
      const urlParts = this.props.Router.location.pathname.split('/');
      const dynamicUrlArray = [];
      let dynamicUrl = '/';
      const urlPartCnt = (urlParts.length - paramArray.length);
      let iCnt = 0;
      while (iCnt < urlPartCnt) {
        if (urlParts[iCnt] && urlParts[iCnt].trim().length > 0) {
          dynamicUrlArray.push(urlParts[iCnt]);
        }
        iCnt += 1;
      }
      dynamicUrl += dynamicUrlArray.join(dynamicUrl);
      if (paramArray && paramArray.length > 0) {
        iCnt = 0;
        dynamicUrl += '(';
        while (iCnt < paramArray.length) {
          dynamicUrl += ('/:' + paramArray[iCnt]);
          iCnt += 1;
        }
        dynamicUrl += ')';
      }
      currentURL = dynamicUrl;
    } else {
      currentURL = this.props.Router.location.pathname;
    }
    Object.keys(breadcrumbConfiguration).forEach((routeConfig) => {
      if (routeConfig === currentURL) {
        const tempRouteConfig = JSON.parse(JSON.stringify(breadcrumbConfiguration[routeConfig]));
        if (!Array.isArray(tempRouteConfig)) {
          currentBreadCrumbConfiguration = tempRouteConfig[currentPage];
        } else {
          currentBreadCrumbConfiguration = tempRouteConfig;
        }
      }
    });
    return currentBreadCrumbConfiguration;
  }
  isEventCreationPage = false;
  render() {
    const breadcrumbs = this._createBreadCrumb();
    if (breadcrumbs && breadcrumbs.length < 1) {
      return null;
    }
    const eventDetailsData = this.props.eventDetails && this.props.eventDetails.data && this.props.eventDetails.data.eventList;
    let mesadeRegalosPath =  applicationRoutes.home || '/';
    // if (eventDetailsData && eventDetailsData.length === 1) {
    //   mesadeRegalosPath = commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventDetailsData[0].eventId });
    // } else if (eventDetailsData && eventDetailsData.length > 1) {
    //   mesadeRegalosPath = applicationRoutes.multipleEvents;
    // } else {
    //   mesadeRegalosPath = applicationRoutes.home;
    // }
    if(this.props.Router.location.pathname && this.props.Router.location.pathname.includes('/crearevento/')) {
      this.isEventCreationPage = true;
    } else {
      this.isEventCreationPage = false;
    }
    return (
      <div className="adminContainer">
        <div className={`giftBreadcrumbs giftBreadcrumbs-EM giftBreadcrumbsLarge ${this.isEventCreationPage ? 'event-breadCrumbs' : ''}`}>
          <ul className='breadcrumb-evnt'>
            {breadcrumbs && breadcrumbs.length > 0 ? breadcrumbs.map((trail, index) => {
              // const Regex = '^//';
              // const regex = new RegExp(Regex);
              // const result = regex.test(trail.route);
              if (trail.displayName === 'Home') {
                const homeRoute = serverClientUtil.getLPFullURL('home');
                const json = {};
                if(homeRoute && homeRoute.indexOf('?') > - 1){
                  json.href = homeRoute.split('?')[0];
                }else{
                  json.href = homeRoute;
                }
                json.id = trail.displayName;
                json.cssClass = index === (breadcrumbs.length - 1) ? 'current activeURL' : '';
                return (
                  <li key={'breadcrumb_' + index}>
                    <Link linkJSON={json} >{trail.displayName}</Link>
                    <i className="glyphicon glyphicon-menu-right" /></li>);
              }
              if (trail.displayName === 'Mesa de Regalos') {
                const ljson = {};
                ljson.href = mesadeRegalosPath;
                ljson.id = trail.displayName;
                ljson.cssClass = index === (breadcrumbs.length - 1) ? 'current activeURL' : '';
                return (
                  <li key={'breadcrumb_' + index}>
                    <Link linkJSON={ljson} >{trail.displayName}</Link>
                    <i className="glyphicon glyphicon-menu-right" /></li>);
              }
              const actualRoute = trail;
              actualRoute.route = commonUtil.getRouteByParameter(trail.route, this.props.params);
              return (
                <li key={'breadcrumb_' + index}>
                  <Link rrLink={actualRoute} classname={index === (breadcrumbs.length - 1) ? 'current activeURL' : ''} />
                  <i className="glyphicon glyphicon-menu-right" /></li>);
            }) : null}
          </ul>
        </div>
      </div>
    );
  }
}

